// eslint-disable-next-line no-restricted-imports -- v5 form stack, migrate to v7 (DX-194)
import * as yup from 'yup-legacy';
import {
  CategorySchemaType,
  InventoryDetailsSchemaType,
  InventorySchemaType,
} from './types';

export const categorySchema = yup.object().shape<CategorySchemaType>({
  category: yup.string().required(),
});
export const inventorySchema = yup.object().shape<InventorySchemaType>({
  name: yup.string().nullable().required(),
});
export const inventoryDetailsSchema = yup
  .object()
  .shape<InventoryDetailsSchemaType>({
    manufacturer: yup.string().required(),
    model: yup.string().required(),
    serialNumber: yup.string().required(),
  });
